import axios from "axios";
import url from "../config/urlServiceConfig";
import { delegation } from "../config/httpServiceConfig";

const delegationAPI = {
  getAll: () => axios.get(url.delegation),
  getById: id => axios.get(`${url.delegation}/${id}`),
  create: body => axios.post(url.delegation, body),
  update: body => axios.put(url.delegation, body),
  delete: id => axios.delete(`${url.delegation}/${id}`),
  activate: id => axios.post(`${url.delegation}/ActivateDelegation/${id}`),
  getActive: () => delegation.get(`${url.delegation}/ActiveDelegation`)
};

export default delegationAPI;
